module.exports = __webpack_public_path__ + "media/images/contar2-76b7c6daedba1f9a6c2aeb2dbe924859.png";